import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {AuthService} from '../../auth/auth.service';
import {NavBaseComponent} from '../nav-base/nav-base.component';
import {TranslateService} from '../../shared/translate.service';
import {HtmlUtilsService} from "../../html-utils/html-utils.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-nav-account',
  templateUrl: './nav-account.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss']
})
export class NavAccountComponent extends NavBaseComponent implements OnInit{

  @Output() showAccountEmitter = new EventEmitter<boolean>();

  showAccount = false;

  showAccountMobile = false;

  isMobile = false;

  loggedIn = false;

  username: string = '';

  constructor(public authService: AuthService,
              public translateService: TranslateService,
              private htmlUtils: HtmlUtilsService,
              private route: Router) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.authService.isLogged.subscribe(value => {
      this.loggedIn = value;
    });
    let currentUser = this.authService.currentUserValue;
    if (currentUser && currentUser.email) {
      this.username = currentUser.email;
    }
    this.isMobile = this.htmlUtils.mobileVersion;
    this.htmlUtils.mobileBehaviorSubject.subscribe(value => {
      this.isMobile = value;
    })
  }

  logout() {
    this.authService.logout();
  }

  login() {
    this.route.navigateByUrl('/login');
  }

  toggleAccount(mobile: boolean = false) {
    this.showAccountMobile = mobile;
    this.showAccount = !this.showAccount;
    this.showAccountEmitter.emit(!this.showAccount);
  }

}
